import { formatCurrency } from '@ibk/shared-utils';
import { LimitTarget } from '../types/limits';
function extractLimitsErrorResult(error) {
    const err = error;
    const detailsResult = err?.details?.result;
    if (detailsResult?.error)
        return detailsResult;
    const dataResult = err?.data?.result;
    if (dataResult?.error)
        return dataResult;
    const directResult = err?.result;
    if (directResult?.error)
        return directResult;
    const nestedData = err?.data;
    if (nestedData?.status && nestedData?.result) {
        return nestedData.result;
    }
    return undefined;
}
function formatMetaValue(value) {
    if (!value)
        return '';
    return formatCurrency(value);
}
function getErrorKeyForTarget(baseKey, limitTarget) {
    if (limitTarget === LimitTarget.PERSON) {
        return `${baseKey}-person`;
    }
    if (limitTarget === LimitTarget.ORGANIZATION) {
        return `${baseKey}-organization`;
    }
    return baseKey;
}
function handleNightlyExceedsDailyError(meta, t) {
    const nightlyValue = formatMetaValue(meta?.nightlyValue);
    const dailyValue = formatMetaValue(meta?.dailyValue);
    const errorKey = getErrorKeyForTarget('limits.error-nightly-exceeds-daily', meta?.limitTarget);
    return t(errorKey, { nightlyValue, dailyValue });
}
function handleExceedsMaximumError(meta, t) {
    const requestedValue = formatMetaValue(meta?.requestedValue);
    const maxAllowed = formatMetaValue(meta?.maxAllowed);
    const errorKey = getErrorKeyForTarget('limits.error-exceeds-maximum', meta?.limitTarget);
    return t(errorKey, { requestedValue, maxAllowed });
}
export function mapLimitsErrorToMessage(error, t) {
    const result = extractLimitsErrorResult(error);
    if (!result?.error || result.error !== 'BUSINESS_EXCEPTION') {
        return t('limits.error');
    }
    const errorMessage = result.message ?? '';
    const { meta } = result;
    if (errorMessage.includes('cannot exceed daily limit')) {
        return handleNightlyExceedsDailyError(meta, t);
    }
    if (errorMessage.includes('exceeds maximum allowed')) {
        return handleExceedsMaximumError(meta, t);
    }
    return t('limits.error');
}
